<itfg-ccr-report [inputClient]="client"></itfg-ccr-report>
